// extracted by mini-css-extract-plugin
export default {"wrap":"Header_wrap__9pzRy","logo":"Header_logo__HPdCe"};